import dataOptionService from './service'
import helpers from './helpers'

export default {
  initialise ({state, commit, dispatch}, data) {
    return new Promise((resolve, reject) => {
      Promise.all([
        dispatch('loadSystemOptions'),
        dispatch('loadSystemOptionTypes'),
        dispatch('loadCurrencies'),
        dispatch('loadCountries'),
        dispatch('loadBrandGroups')
      ])
      .then(resolve)
      .catch(reject)
    })
  },
  loadFinancialCodes ({state, commit, dispatch}, data) {
    return new Promise((resolve, reject) => {
      if (state.financialCodes.length === 0) {
        dataOptionService.getFinancialCodes()
          .then(({data}) => {
            helpers.handle({commit, resolve, reject, mutation: 'SET_FINANCIAL_CODES'}, data)
          })
          .catch((err) => {
            console.log(err)
            reject(err)
          })
      } else {
        resolve()
      }
    })
  },
  loadRoles ({state, commit, rootState}, data) {
    return new Promise((resolve, reject) => {
      if (state.roles.length === 0) {
        dataOptionService.getRoles()
          .then(({data}) => {
            helpers.handle({commit, resolve, reject, mutation: 'SET_ROLES'}, data)
          })
          .catch((err) => {
            console.log(err)
            reject(err)
          })
      } else {
        resolve()
      }
    })
  },
  loadUserGroups ({state, commit, rootState}, data) {
    return new Promise((resolve, reject) => {
      if (state.userGroups.length === 0) {
        dataOptionService.getUserGroups()
          .then(({data}) => {
            helpers.handle({commit, resolve, reject, mutation: 'SET_USER_GROUPS'}, data)
          })
          .catch((err) => {
            console.log(err)
            reject(err)
          })
      } else {
        resolve()
      }
    })
  },
  loadPartyGroups ({state, commit, rootState}, data) {
    return new Promise((resolve, reject) => {
      if (state.partyGroups.length === 0 || (data && data.forceReload)) {
        dataOptionService.getPartyGroups()
          .then(({data}) => {
            helpers.handle({commit, resolve, reject, mutation: 'SET_PARTY_GROUPS'}, data)
          })
          .catch((err) => {
            console.log(err)
            reject(err)
          })
      } else {
        resolve()
      }
    })
  },
  loadPortAreas ({state, commit, rootState}, data) {
    return new Promise((resolve, reject) => {
      if (state.portAreas.length === 0) {
        dataOptionService.getPortAreas()
          .then(({data}) => {
            helpers.handle({commit, resolve, reject, mutation: 'SET_PORT_AREAS'}, data)
          })
          .catch((err) => {
            console.log(err)
            reject(err)
          })
      } else {
        resolve()
      }
    })
  },
  loadServiceTypes ({state, commit, rootState}, data) {
    return new Promise((resolve, reject) => {
      if (state.serviceTypes.length === 0) {
        dataOptionService.getServiceTypes()
          .then(({data}) => {
            helpers.handle({commit, resolve, reject, mutation: 'SET_SERVICE_TYPES'}, data)
          })
          .catch((err) => {
            console.log(err)
            reject(err)
          })
      } else {
        resolve()
      }
    })
  },
  loadSystemOptions ({state, commit, rootState}, data) {
    return new Promise((resolve, reject) => {
      if (state.dataOptions.length === 0) {
        dataOptionService.getOptions()
          .then(({data}) => {
            helpers.handle({commit, resolve, reject, mutation: 'SET_SYSTEM_OPTIONS'}, data)
          })
          .catch((err) => {
            console.log(err)
            reject(err)
          })
      } else {
        resolve()
      }
    })
  },
  loadSystemOptionTypes ({state, commit, rootState}, data) {
    return new Promise((resolve, reject) => {
      if (state.dataOptionTypes.length === 0) {
        dataOptionService.getOptionTypes()
          .then(({data}) => {
            helpers.handle({commit, resolve, reject, mutation: 'SET_SYSTEM_OPTION_TYPES'}, data)
          })
          .catch((err) => {
            console.log(err)
            reject(err)
          })
      } else {
        resolve()
      }
    })
  },
  loadChargeProfiles ({state, commit, rootState}, data) {
    return new Promise((resolve, reject) => {
      if (state.chargeProfiles.length === 0) {
        dataOptionService.getChargeProfiles()
          .then(({data}) => {
            helpers.handle({commit, resolve, reject, mutation: 'SET_CHARGES'}, data)
          })
          .catch((err) => {
            console.log(err)
            reject(err)
          })
      } else {
        resolve()
      }
    })
  },
  loadCurrencies ({state, commit, rootState}, data) {
    return new Promise((resolve, reject) => {
      if (state.currencies.length === 0) {
        dataOptionService.getCurrencies()
          .then(({data}) => {
            helpers.handle({commit, resolve, reject, mutation: 'SET_CURRENCIES'}, data)
          })
          .catch((err) => {
            console.log(err)
            reject(err)
          })
      } else {
        resolve()
      }
    })
  },
  loadBrandGroups ({state, commit, rootState}, data) {
    return new Promise((resolve, reject) => {
      if (state.brandGroups.length === 0) {
        dataOptionService.getBrandGroups()
          .then(({data}) => {
            helpers.handle({commit, resolve, reject, mutation: 'SET_BRAND_GROUPS'}, data)
          })
          .catch((err) => {
            console.log(err)
            reject(err)
          })
      } else {
        resolve()
      }
    })
  },
  loadCalculations ({state, commit, rootState}, data) {
    return new Promise((resolve, reject) => {
      if (state.calculations.length === 0) {
        dataOptionService.getCalculations()
          .then(({data}) => {
            helpers.handle({commit, resolve, reject, mutation: 'SET_CALCULATIONS'}, data)
          })
          .catch((err) => {
            console.log(err)
            reject(err)
          })
      } else {
        resolve()
      }
    })
  },
  loadJobTypes ({state, commit, rootState}, data) {
    return new Promise((resolve, reject) => {
      if (state.jobTypes.length === 0) {
        dataOptionService.getJobTypes()
          .then(({data}) => {
            helpers.handle({commit, resolve, reject, mutation: 'SET_JOB_TYPES'}, data)
          })
          .catch((err) => {
            console.log(err)
            reject(err)
          })
      } else {
        resolve()
      }
    })
  },
  loadCountries ({state, commit, rootState}, data) {
    return new Promise((resolve, reject) => {
      if (state.countries.length === 0) {
        dataOptionService.getCountries()
          .then(({data}) => {
            helpers.handle({commit, resolve, reject, mutation: 'SET_COUNTRIES'}, data)
          })
          .catch((err) => {
            console.log(err)
            reject(err)
          })
      } else {
        resolve()
      }
    })
  },
  loadExchangeRates ({state, commit, rootState}, data) {
    return new Promise((resolve, reject) => {
      if (state.exchangeRates.length === 0) {
        dataOptionService.getExRates()
          .then(({data}) => {
            helpers.handle({commit, resolve, reject, mutation: 'SET_EX_RATES'}, data)
          })
          .catch((err) => {
            console.log(err)
            reject(err)
          })
      } else {
        resolve()
      }
    })
  },
  loadSpreadsheetDescriptorProperties ({state, commit, dispatch}, data) {
    return new Promise((resolve, reject) => {
      Promise.all([
        dispatch('loadTariffDescriptorProperties'),
        dispatch('loadLineDescriptorProperties'),
        dispatch('loadStaticDescriptorProperties'),
        dispatch('loadNoteDescriptorProperties')
      ]).then(resolve).catch(reject)
    })
  },
  loadTariffDescriptorProperties ({state, commit, rootState}, data) {
    return new Promise((resolve, reject) => {
      if (state.tariffDescriptorProperty.length === 0) {
        dataOptionService.getSpreadsheetDescriptorProperties('tariff')
          .then(({data}) => {
            helpers.handle({commit, resolve, reject, mutation: 'SET_TARIFF_DESCRIPTOR_PROPERTIES'}, data)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      } else {
        resolve()
      }
    })
  },
  loadLineDescriptorProperties ({state, commit, rootState}, data) {
    return new Promise((resolve, reject) => {
      if (state.lineDescriptorProperty.length === 0) {
        dataOptionService.getSpreadsheetDescriptorProperties('line')
          .then(({data}) => {
            helpers.handle({commit, resolve, reject, mutation: 'SET_LINE_DESCRIPTOR_PROPERTIES'}, data)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      } else {
        resolve()
      }
    })
  },
  loadStaticDescriptorProperties ({state, commit, rootState}, data) {
    return new Promise((resolve, reject) => {
      if (state.staticDescriptorProperty.length === 0) {
        dataOptionService.getSpreadsheetDescriptorProperties('static')
          .then(({data}) => {
            helpers.handle({commit, resolve, reject, mutation: 'SET_STATIC_DESCRIPTOR_PROPERTIES'}, data)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      } else {
        resolve()
      }
    })
  },
  loadNoteDescriptorProperties ({state, commit, rootState}, data) {
    return new Promise((resolve, reject) => {
      if (state.noteDescriptorProperty.length === 0) {
        dataOptionService.getSpreadsheetDescriptorProperties('note')
          .then(({data}) => {
            helpers.handle({commit, resolve, reject, mutation: 'SET_NOTE_DESCRIPTOR_PROPERTIES'}, data)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      } else {
        resolve()
      }
    })
  },
  updateCache ({state, commit, rootState}, { cacheProperty, data }) {
    commit('UPDATE_CACHE', { cacheProperty, data })
  }
}



// WEBPACK FOOTER //
// ./src/modules/systemoptions/store/actions.js